module.exports = __webpack_public_path__ + "img/premiation-1-perfumes.713dc88c.png";